import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  rows: [],
  hasMore: false,
  loading: false,
  error: null,
  filters: { searchValue: '', locationId: '', sortOrder: 'asc' },
};

const slice = createSlice({
  name: 'businessDirectory',
  initialState,
  reducers: {
    filtersChanged(state, { payload }) {
      state.filters = { ...state.filters, ...payload };
    },
    fetchStarted(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSucceeded(state, { payload: { rows, hasMore, append } }) {
      state.rows = append ? state.rows.concat(rows) : rows;
      state.hasMore = hasMore;
      state.loading = false;
    },
    fetchFailed(state, { payload }) {
      state.loading = false;
      state.error = payload;
    },
    errorCleared(state) {
      state.error = null;
    },
    reset: () => initialState,
  },
});

export const businessDirectoryActions = slice.actions;

export default slice.reducer;
